<div>
    <div style="margin-left: 80%; margin-bottom: 2%">
        <button  *ngIf="updateStatus" class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button
        color="primary" (click)="saveSubscriptionBarcodesDataEntry()">
        save
    </button>
     <button class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button
            color="primary" printTitle="Pincodewise Statement" printSectionId="print-section" ngxPrint>
            print
        </button> 
        <button *ngIf="!updateStatus" [disabled]="deleteStatewiseStatemet" class="noPrint" style="margin-right: 2%; margin-left: 2%;background-color: #f5365c;" mat-raised-button
        color="primary" (click)="deleteStatewiseStatementList()">
        delete
    </button>

        <!-- <button mat-raised-button class="btn btn-info noPrint" (click)="print()"
            style="margin-right: 2%; margin-left: 2%">
            Print
        </button> -->
        <button mat-dialog-close class="btn noPrint">Close</button>
    </div>
    <div class="container" id="print-section">
        <div style="margin: 0px 15px;">
            <div class="row" 
                style="text-align: center;border-width: 1px 1px 1px 1px; border-style: solid; border-color: black;padding-top: 05px; padding-bottom: 04px;">
                <span style=" font-size: 17px;font-weight: 600;margin: auto;">मा. विवेक, प्रभादेवी - २५ दि
                    {{sundayankDate}}
                    च्या
                    अंकाकरिता
                    पोस्ट स्टेटमेंट
                    वितरण दि {{dispatchankDate}}</span>
            </div>
            <div class="row">
                <div class="col" *ngIf="!updateStatus" style="border-bottom: 0.5px solid #000; border-right: 0.5px solid #000;font-size: 16px;">
                    
                    <label>
                        <input type="checkbox" [(ngModel)]="masterSelected" (change)="checkUncheckAll()"> All
                    </label>Index
                </div>
                <div class="col"   style="border-bottom: 0.5px solid #000; border-left: 0.5px solid #000; border-right: 0.5px solid #000;font-size: 16px;" > 
                    जिल्हा</div>
                <div class="col" style="border-bottom: 0.5px solid #000; border-right: 0.5px solid #000;font-size: 16px;">वर्गणीदार संख्या</div>
            </div>
            <div class="row"  *ngFor="let data of groupedStates; let i=index">
                <div class="col"   *ngIf="!updateStatus" style="border-bottom: 0.5px solid #000; border-left: 0.5px solid #000; border-right: 0.5px solid #000;"> <input type="checkbox" [(ngModel)]="data.selected" (change)="isAllSelected()">{{ i+1 }}</div>

                <div class="col" style="border-bottom: 0.5px solid #000; border-left: 0.5px solid #000; border-right: 0.5px solid #000;"> <input type="checkbox" [(ngModel)]="data.selected" (change)="isAllSelected()">{{ data['state'] }}</div>
                <div class="col" style="border-bottom: 0.5px solid #000; border-right: 0.5px solid #000;">{{ data['count']
                    }}</div>
            </div>
            <div class="row">
                <div class="col" style="border-bottom: 1px solid #000; border-left: 1px solid #000; border-right: 1px solid #000;border-bottom: 1px solid #000; font-weight: bold;">एकूण</div>
                <div class="col" style="border-bottom: 1px solid #000; border-left: 1px solid #000; border-right: 1px solid #000;border-bottom: 1px solid #000; font-weight: bold;">{{totalcount}}</div>
                
            </div>
        </div>
    </div>
</div>